import useProjects from "./../../hooks/useProjects";
import ProjectCard from "./ProjectCard";
import "./Projects.css";

const Projects = () => {
  const [projects, setProjects] = useProjects();
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="3000"
      className="container my-5"
      id="projects"
    >
      <h1 className="text-center fw-bold text-uppercase">Projects</h1>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-5 mb-4">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
